import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';

const StyledRating = styled(Rating, {
  shouldForwardProp: (prop) =>
    prop !== 'filledColor' && prop !== 'hoverColor' && prop !== 'emptyColor',
})(({ filledColor, hoverColor, emptyColor }) => ({
  '& .MuiRating-iconFilled': {
    color: filledColor || '#ff6d75',
  },
  '& .MuiRating-iconHover': {
    color: hoverColor || '#ff3d47',
  },
  '& .MuiRating-iconEmpty': {
    color: emptyColor || '#ffffff', 
  },
}));

const DynamicRating = ({
  name = 'rating',
  value = 0, 
  max = 5,
  precision = 0.5,
  size = 'medium',
  label = '',
  filledIcon,
  emptyIcon,
  filledColor,
  hoverColor,
  emptyColor, 
  readOnly = false,
  onChange,
}) => {
  return (
    <Box sx={{ '& > legend': { mt: 2 } }}>
      {label && <Typography component="legend" style={{ marginBottom: "10px" }}>{label}</Typography>}
      <StyledRating
        name={name}
        value={value} 
        max={max}
        precision={precision}
        size={size}
        icon={filledIcon}
        emptyIcon={emptyIcon}
        filledColor={filledColor}
        hoverColor={hoverColor}
        emptyColor={emptyColor}
        readOnly={readOnly}
        onChange={onChange}
        getLabelText={(value) => `${value} Star${value !== 1 ? 's' : ''}`}
      />
    </Box>
  );
};

export default DynamicRating;